export enum EducationLevelFilterOptionValue {
	MASTER = "master",
	BACHELOR = "bachelor",
	PHD = "phd",
	DISTANCE_LEARNING = "distance_learning",
	PREPARATION_COURSE = "preparation_course",
	SHORT_COURSE = "short"
}
